// extracted by mini-css-extract-plugin
export default {"navbar":"Navigation_navbar__k8lLS","logo":"Navigation_logo__dkuDn"};